import { render, staticRenderFns } from "./authorizedList.vue?vue&type=template&id=546b2e94&scoped=true&"
import script from "./authorizedList.vue?vue&type=script&lang=js&"
export * from "./authorizedList.vue?vue&type=script&lang=js&"
import style0 from "./authorizedList.vue?vue&type=style&index=0&id=546b2e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b2e94",
  null
  
)

export default component.exports